// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"c437185b","453":"325ebe0b"}[chunkId] + ".chunk.js";
};